module.exports = __webpack_public_path__ + "static/media/2025-Summer-of-Cricket-Banner.777fcfac.webp";